<div *ngIf="gs.showSpinner$ | async" class="scrim" [class.full]="(ns.currentLayer$ | async)?.hidden">
  <zef-spinner size="huge" mode="indeterminate"></zef-spinner>
</div>
